<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" viewBox="0 0 4175 3006">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame" />
      </clipPath>
      <g clip-path="url(#clip-frame)">
        <g ref="main">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/foster/main-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/foster/main-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/foster/main-1280w.jpg`" media="(max-width: 1280px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/foster/main.jpg`" />
            </picture>
          </foreignObject>
        </g>
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.52"
      :tx="0.12" :ty="0.75"
      :fontSize="22">
      The court was changing into the Navajo Nation Court. He stepped down
      after four years. His wife, Gertie, died, and he was starting to get
      ill. But, knowing Max, he wasn’t done just like that. He took a
      part-time job as a janitor at the Bureau of Indian Affairs school in
      Kayenta. Around that time, another one of Max’s brothers, Uncle John Blue
      Salt, started the Foster Grandparent Program in Shonto Boarding School.
      Max was one of his first enthusiastic volunteers.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/foster/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const main = this.$refs["main"]
    const d = this.$refs["dialogue"].$el
    TweenLite.set(main, {opacity: 0, scale: 1.2, transformOrigin: "20% center"})
    TweenLite.set(d, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 3, {opacity: 1, scale: 1}), 0.5)
    this.tl.add(TweenLite.to(d, 1, {opacity: 1}), "-=1")
  },
  methods: {
    enter() {this.tl.play()}
  },
  components: {
    SceneDialogue,
  }
}
</script>

<style lang="css" scoped>
</style>
